<template>
	<MountingPortal
		mountTo="#booking-receipt--sticky"
		:to="stickyContainer"
		name="source"
		target-slim
	>
		<div id="booking-receipt--sticky" class="booking-receipt--sticky hidden-md" :class="{'booking-receipt--sticky-app': isApp}" data-progress="10">

			<div class="left">
				<CurrencyPopup :showCurrencyPopup="showCurrencySelector" :currencies="currencies" :currencyModule="currencyModule" @hide="hidePopup" @changeCurrency="hidePopup" />
				<p v-if="total.length">
					<span v-html="total[0].value[0]"></span>
					<a class="edit-toggle edit-toggle--info" href="#" data-target="#booking-receipt"></a>
					<br>
					<a href="#" class="currencyLink" @click.prevent="hidePopup" v-if="showCurrencySelector">{{ language.changeCurrency }}</a>
					<a href="#" class="currencyLink" @click.prevent="openPopup" v-else>{{ language.changeCurrency }}</a>
				</p>
				<p v-else>
					<b>{{ outputDates }}</b>
					<a class="edit-toggle" :href="appEditLink" v-if="appEditLink" :aria-label="language.editDates"></a>
					<a class="edit-toggle" href="#" data-target="#booking-receipt" :aria-label="language.editDates" v-else></a>
					<br>
					{{ outputNights }}
				</p>
			</div>
			<div class="right">
				<Button id="continueButton" :currentlyLoading=currentlyLoading :active=active />
			</div>
			<a class="clicker" href="#" data-target="#booking-receipt" tabindex="-1"></a>
		</div>
	</MountingPortal>
</template>
<script>

import Button from './ButtonLg'
import CurrencyPopup from './CurrencyPopup'
import moment from 'moment/src/moment'

export default {
	name: 'StickyWidget',

	components: {
		Button,
		CurrencyPopup
	},

	props: {
		active: {
			type: Boolean,
			default: true
		},
	},

	data: function () {
		return {
			stickyContainer: 'sticky',

			target: null,
			currencies: null,
			currencyModule: null,
			showCurrencySelector: false,
			isApp: false,
		}
	},

	mounted() {
		// there is an event implemented for wmx scripts to be loaded
		const that = this
		document.body.addEventListener('wmx:loaded', function(){
			that.currencies = Object.assign({}, window.currency_symbols)
			that.currencyModule = window.citizenm.currencyModule
		})
		if(document.querySelector('aside.aside--app')){
			this.isApp = true
		}
	},

	computed: {
		language: function () {
			return this.$store.state.language
		},
		total: function () {
			return this.$store.state.total
		},
		appEditLink: function () {
			return this.$store.state.appEditLink
		},
		continueButton: function () {
			return this.$store.state.continueButton
		},
		outputDates: function () {
			return moment(this.arrival).format(this.$store.state.dateFormatUltraShort) + ' - ' + moment(this.departure).format(this.$store.state.dateFormatUltraShort)
		},
		outputNights: function () {
			const nights = moment(this.departure).diff(moment(this.arrival), 'days')
			return nights + ' ' + (nights > 1 ? 'nights' : 'night')
		},
		arrival: function () {
			return this.$store.state.arrival
		},

		departure: function () {
			return this.$store.state.departure
		},

		currentlyLoading: function () {
			return this.$store.state.currentlyLoading
		},
	},

	methods: {
		openPopup() {
			this.showCurrencySelector = true
		},
		hidePopup() {
			this.showCurrencySelector = false
		},
		currencyChanged() {
			//this.$emit('changeCurrency')
			this.showCurrencySelector = false
		}
	},
}
</script>
<style scoped>
.booking-receipt--sticky .popupWrapper {
	position: absolute;
}
</style>